'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Top;
(function (Top) {
    var MyTop = /** @class */ (function () {
        function MyTop() {
            var _this = this;
            // PCより大きいサイズ
            this.OVERPCWIDTH = 1200;
            this.TOPHEIGHT = 1080;
            // 真剣に神研しよう
            this.initializeCopyWidth = 680;
            this.initializeCopyHeight = 420;
            // 神戸薬科大学で研究しよう
            this.initializeSubWidth = 684;
            this.initializeSubHeight = 292;
            var self = this;
            $(window).on('load', function () {
                _this.resizeTopView();
            });
            $(window).on('resize', function () {
                _this.resizeTopView();
            });
        }
        MyTop.prototype.isPcWidth = function () {
            var isPcWidth = false;
            var browserWidth = $(window).outerWidth();
            if (browserWidth >= this.OVERPCWIDTH) {
                isPcWidth = true;
            }
            return isPcWidth;
        };
        MyTop.prototype.resizeTopView = function () {
            if (this.isPcWidth()) {
                var browserHeight = $(window).outerHeight();
                $('.bulletTopWrap').css('height', browserHeight);
                $('.bulletTopBlock').css('height', browserHeight);
                this.resizeTopCopy();
                this.resizeTopSub();
            }
        };
        MyTop.prototype.calculateScale = function () {
            var browserHeight = $(window).outerHeight();
            return browserHeight / this.TOPHEIGHT;
        };
        MyTop.prototype.resizeTopCopy = function () {
            var scale = this.calculateScale();
            var changeWidth = this.initializeCopyWidth * scale;
            var changeHeight = this.initializeCopyHeight * scale;
            $('.bulletTopCopy').css({ 'width': changeWidth, 'height': changeHeight });
        };
        MyTop.prototype.resizeTopSub = function () {
            var scale = this.calculateScale();
            var changeWidth = this.initializeSubWidth * scale;
            var changeHeight = this.initializeSubHeight * scale;
            $('.bulletTopSub').css({ 'width': changeWidth, 'height': changeHeight });
        };
        return MyTop;
    }());
    Top.MyTop = MyTop;
})(Top || (Top = {}));
exports.default = Top;
